import {
  AtlasBodyMain,
  AtlasCaption,
  AtlasColor,
  CardComponent,
  Divider
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { FabButtonAtom } from 'components/atoms/FabButton.atom'
import { StackAtom } from 'components/atoms/Stack.atom'
import { ImageMolecule } from 'components/molecule/Image.molecule'
import type { ProductType } from 'types/assembly/model'

interface ProductCardOrganismProps {
  product: ProductType
  quantityLabel?: string
  actionIcon?: string
  onClickAction?: () => void
}

export const ProductCardOrganism = (props: ProductCardOrganismProps) => {
  const {
    product: {
      imgUrl,
      name,
      barcode,
      sku,
      quantity,
      containerId,
      measureUnit,
      isStockOut
    },
    quantityLabel,
    actionIcon,
    onClickAction
  } = props

  return (
    <CardComponent>
      <StackAtom $direction="column" $gap={8}>
        <StackAtom $gap={12}>
          <ImageMolecule
            src={imgUrl}
            size={60}
            alt="product-img"
            tagBg="#D33641"
            icon={
              isStockOut ? (
                <Icon name="arrow_up" color="white" size={24} />
              ) : undefined
            }
          />

          <StackAtom $direction="column" $gap={8} style={{ flex: 1 }}>
            <StackAtom $justify="space-between" $align="center" $gap={10}>
              <AtlasBodyMain style={{ fontWeight: 700 }}>{name}</AtlasBodyMain>
              {actionIcon && (
                <FabButtonAtom
                  style={{ minWidth: '32px', padding: 0 }}
                  type="button"
                  $variant="secondary"
                  $alignSelf="self-start"
                  onClick={onClickAction}
                >
                  <Icon name={actionIcon} color={AtlasColor.Primary} />
                </FabButtonAtom>
              )}
            </StackAtom>
            <AtlasCaption
              style={{ fontWeight: 700 }}
            >{`UPC: ${barcode} | SKU: ${sku}`}</AtlasCaption>
          </StackAtom>
        </StackAtom>

        <Divider />

        <StackAtom $direction="column" $gap={8}>
          <StackAtom $justify="space-between">
            <AtlasBodyMain>
              {quantityLabel || 'Cantidad solicitada:'}
            </AtlasBodyMain>
            <AtlasBodyMain style={{ fontWeight: 700 }}>
              {quantity}{' '}
              {measureUnit === 'kg'
                ? 'gr'
                : measureUnit === 'CAJA'
                  ? 'cajas'
                  : 'unidades'}
            </AtlasBodyMain>
          </StackAtom>

          {containerId && (
            <StackAtom $justify="space-between">
              <AtlasBodyMain>Tarima:</AtlasBodyMain>
              <AtlasBodyMain style={{ fontWeight: 700 }}>
                {containerId}
              </AtlasBodyMain>
            </StackAtom>
          )}
        </StackAtom>
      </StackAtom>
    </CardComponent>
  )
}
